import { createContext } from "react";

export const happinessResChange = createContext();

export const happinessGoalChange = createContext();

export const followersChange = createContext();

export const ProfileImageContext = createContext();

export const LogInCall = createContext();

export const userNameContext = createContext();

export const videoCallContext = createContext();

export const rtcPropsContext = createContext();

export const bithappierWalletContext = createContext();

export const mentalHappinessResponseContext = createContext();

export const isProfileCompleteContext = createContext();

export const completePercentageContext = createContext();

export const walletBalanceContext = createContext();

export const usdAmountContext = createContext();

export const userIp = createContext();
